<div class="container-fluid">
  <cal-calsiumlist-listing [config]="listConfig" (filterTriggered)="onFilter($event)" (clearFilterAndSortingTriggered)="onClearFilterAndSorting()"
   [filterExpression]="filterExpression | async" [ListBodyData]="material.materialPrices" [dataTotalCount]="material.materialPrices.length"
    (sortTriggered)="onSort($event)">
  </cal-calsiumlist-listing>
</div>
